import { styled } from 'styled-components';
import { Typography } from '@altibox/design-system-component-lib';

import { spacing1, spacing2 } from 'src/styles/spacing';

export const StyledMessageContainer = styled.div`
  display: flex;
  margin-top: ${spacing1};
  align-items: flex-start;
`;

export const StyledMessage = styled(Typography)`
  font-weight: bold;
  margin-left: ${spacing2};
`;
